/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getTestFilters$Json } from '../fn/automated-test/get-test-filters-json';
import { GetTestFilters$Json$Params } from '../fn/automated-test/get-test-filters-json';
import { getTestFilters$Plain } from '../fn/automated-test/get-test-filters-plain';
import { GetTestFilters$Plain$Params } from '../fn/automated-test/get-test-filters-plain';
import { startTestRun$Json } from '../fn/automated-test/start-test-run-json';
import { StartTestRun$Json$Params } from '../fn/automated-test/start-test-run-json';
import { startTestRun$Plain } from '../fn/automated-test/start-test-run-plain';
import { StartTestRun$Plain$Params } from '../fn/automated-test/start-test-run-plain';
import { TestFiltersCto } from '../models/test-filters-cto';
import { TestRunDispatchResultCto } from '../models/test-run-dispatch-result-cto';

@Injectable({ providedIn: 'root' })
export class AutomatedTestService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `startTestRun()` */
  static readonly StartTestRunPath = '/automatedtest/v1/cicd/selfserve';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startTestRun$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  startTestRun$Plain$Response(params?: StartTestRun$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TestRunDispatchResultCto>> {
    return startTestRun$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `startTestRun$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  startTestRun$Plain(params?: StartTestRun$Plain$Params, context?: HttpContext): Observable<TestRunDispatchResultCto> {
    return this.startTestRun$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<TestRunDispatchResultCto>): TestRunDispatchResultCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startTestRun$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  startTestRun$Json$Response(params?: StartTestRun$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TestRunDispatchResultCto>> {
    return startTestRun$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `startTestRun$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  startTestRun$Json(params?: StartTestRun$Json$Params, context?: HttpContext): Observable<TestRunDispatchResultCto> {
    return this.startTestRun$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TestRunDispatchResultCto>): TestRunDispatchResultCto => r.body)
    );
  }

  /** Path part for operation `getTestFilters()` */
  static readonly GetTestFiltersPath = '/automatedtest/v1/cicd/filters';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTestFilters$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTestFilters$Plain$Response(params?: GetTestFilters$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TestFiltersCto>> {
    return getTestFilters$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTestFilters$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTestFilters$Plain(params?: GetTestFilters$Plain$Params, context?: HttpContext): Observable<TestFiltersCto> {
    return this.getTestFilters$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<TestFiltersCto>): TestFiltersCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTestFilters$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTestFilters$Json$Response(params?: GetTestFilters$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TestFiltersCto>> {
    return getTestFilters$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTestFilters$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTestFilters$Json(params?: GetTestFilters$Json$Params, context?: HttpContext): Observable<TestFiltersCto> {
    return this.getTestFilters$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TestFiltersCto>): TestFiltersCto => r.body)
    );
  }

}
